import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon/index' // svg组件
import PAGINATION from '@/components/Pagination/index' //分页组件
import Upload from '@/components/Upload/index' //分页组件
// register globally
Vue.component('svg-icon', SvgIcon)
Vue.component('h-pagination', PAGINATION)
Vue.component('h-upload', Upload)
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
const iconMap = requireAll(req)